import { DiagnosisRegistrationStoreData } from '@/pages/demands/contexts/diagnosis-registration-store'

export interface GeoTagAdapterProps {
  registerData: DiagnosisRegistrationStoreData['registerData']
  selectFilesData: DiagnosisRegistrationStoreData['selectFilesData']
}

export class GeoTagAdapter {
  private registerData
  private selectFilesData

  constructor(props: GeoTagAdapterProps) {
    this.registerData = props.registerData
    this.selectFilesData = props.selectFilesData
  }

  makeFileReference(diagnosisId: string) {
    const { image_type } = this.registerData!

    if (image_type !== 'raw_images_geotag') return

    const input = this.selectFilesData?.geotag?.input?.at(0)!

    return {
      file: input,
      type: 'geotag',
      inputType: 'geotag',
      resumable: false,
      originalFilename: input?.name,
      bucketFilename: `${diagnosisId}.txt`,
    } as const
  }
}
